import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Amplify } from '@aws-amplify/core';
import { Subject } from 'rxjs';
import { generateClient } from '@aws-amplify/api';
import { appSyncConfig } from 'src/app/shared/data/biometrics.constants';
import { BiometricsResponse } from 'src/app/shared/interfaces/biometrics.interface';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { AnalyticService } from 'src/app/shared/services/analytic.service';
import { environment } from 'src/environments/environment';
import * as subscriptions from './graphql/subscriptions';
import { amplifyConfigMapper } from 'src/app/shared/utils/amplify-config-mapper';
@Injectable({
  providedIn: 'root'
})
export class AppSyncBiometricsService {
  constructor(
    private router: Router,
    private analyticsService: AnalyticService
  ) {}

  appSyncResponse = new Subject<BiometricsResponse>();
  createAppsyncClient = generateClient;
  async initAppSyncBiometrics(transactionId: string) {
    const config =
      appSyncConfig[environment.flagEnvironment as keyof typeof appSyncConfig];
    Amplify.configure(amplifyConfigMapper(config));
    const client = this.createAppsyncClient();
    client
      .graphql({
        query: subscriptions.onBiometricResult,
        variables: {
          transactionId: transactionId
        }
      })
      // @ts-ignore
      .subscribe({
        next: ({ value }: any) => {
          this.appSyncResponse.next(value);
        },
        e: (e: any) => {
          console.warn(e);
          const message = e.message ?? '';
          this.analyticsService.uTagLinkError(
            'Error servicio appSyncBiometrics ' + message,
            'error_tech_page'
          );
          this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
        }
      });
  }
}
